import { SeoPageLayout } from "@/components/SeoPageLayout";
import { SeoSection } from "@/components/seo/SeoSection";
import { SeoStyledList } from "@/components/seo/SeoStyledList";
import { SeoHighlightBox } from "@/components/seo/SeoHighlightBox";
import { Sparkles } from "lucide-react";

const KomikNaOtwarcie = () => (
  <SeoPageLayout title="Komik na" titleAccent="otwarcie firmy">
    <SeoSection title="Stand-up na otwarciu firmy lub biura">
      <p>Otwarcie nowej firmy, biura lub oddziału to moment, który zasługuje na wyjątkową oprawę. Profesjonalny komik na otwarciu buduje pozytywną atmosferę, łamie lody między gośćmi i sprawia, że inauguracja staje się wydarzeniem, o którym mówi się długo po. Humor na otwarciu to sygnał, że Twoja firma to miejsce z pozytywną energią i kulturą.</p>
    </SeoSection>

    <SeoSection title="Rodzaje otwarć, na których występujemy">
      <SeoStyledList items={[
        "Grand opening nowego biura lub siedziby",
        "Otwarcie nowego oddziału lub filii",
        "Inauguracja nowej linii produktowej",
        "Otwarcie showroomu lub salonu",
        "Launch nowej marki lub startupu",
        "Przeprowadzka firmy do nowej lokalizacji"
      ]} />
    </SeoSection>

    <SeoSection title="Jak komik uświetnia otwarcie?">
      <p>Komik może poprowadzić całą ceremonię otwarcia, wplatając humor między przemówienia i toasty. Może też wystąpić z krótkim, spersonalizowanym stand-upem nawiązującym do historii firmy, branży czy nowej lokalizacji. Format jest zawsze dopasowany do charakteru wydarzenia - od luźnego i energetycznego po elegancki i korporacyjny.</p>
      <SeoHighlightBox icon={Sparkles}>
        Komik na otwarciu to inwestycja w pierwszy kontakt z marką - humor buduje pozytywne skojarzenia od pierwszej chwili.
      </SeoHighlightBox>
    </SeoSection>

    <SeoSection title="Zamów komika na otwarcie">
      <p>Niech Twoje otwarcie zacznie się od śmiechu! Skontaktuj się z nami, opisz wydarzenie i gości, a my zaproponujemy idealny format komediowy na inaugurację Twojego nowego rozdziału.</p>
    </SeoSection>
  </SeoPageLayout>
);

export default KomikNaOtwarcie;
